module.exports = __webpack_public_path__ + "static/material-wool.2538e5ce.svg";